import { fg } from '@atlaskit/platform-feature-flags';

import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import {
	NounSubtypeKey,
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SharePointIcon } from './icon';
import { SharepointIconBorderless } from './icon-borderless';
import { SharePointSearchResultIcon } from './search-result-icon';

const getSharePointTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.Document, {
		entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
		subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Pdf],
	});

	config.set(TypeFilterValueKey.Spreadsheet, {
		entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
		subTypes3P: [NounSubtypeKey.Spreadsheet],
	});

	config.set(TypeFilterValueKey.Presentation, {
		entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
		subTypes3P: [NounSubtypeKey.Presentation],
	});

	if (fg('rovo_fps_enable_sharepoint_new_types_filter')) {
		config.set(TypeFilterValueKey.Image, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Image],
		});
		config.set(TypeFilterValueKey.Folder, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Folder],
		});
		config.set(TypeFilterValueKey.Audio, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Audio],
		});
		config.set(TypeFilterValueKey.Video, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Video],
		});
		config.set(TypeFilterValueKey.Pdf, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Pdf],
		});
		config.set(TypeFilterValueKey.Shortcut, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Shortcut],
		});
		config.set(TypeFilterValueKey.Code, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Code],
		});
		config.set(TypeFilterValueKey.Archive, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Archive],
		});
		config.set(TypeFilterValueKey.Form, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Form],
		});
		config.set(TypeFilterValueKey.WebPage, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.WebPage],
		});
		config.set(TypeFilterValueKey.Page, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Page],
		});
		config.set(TypeFilterValueKey.Blogpost, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Blogpost],
		});
		config.set(TypeFilterValueKey.Notebook, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Notebook],
		});
		config.set(TypeFilterValueKey.Other, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Other],
		});
	}

	return config;
};

export const sharepointConfig: ThirdPartyConfig = {
	displayName: 'Microsoft SharePoint',
	id: 'sharepoint',
	resourceType: 'sharepoint-connector',
	icon: get3PLogo(SharePointIcon, 'Sharepoint', 'medium'),
	iconBorderless: get3PLogo(SharepointIconBorderless, 'Sharepoint', 'small'),
	searchResultIcon: get3PLogo(SharePointSearchResultIcon, 'Sharepoint', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	get typeFilterConfig() {
		return getSharePointTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
